import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(
  ({ typography }) => ({
    button: {
      fontSize: 14,
      padding: 0,
      color: 'rgb(9, 131, 117)',
      textDecoration: 'underline',
      '&:hover': {
        textDecoration: 'underline',
        backgroundColor: 'transparent',
      },
    },
    creditAmount: {
      color: '#1E8777',
      fontWeight: typography.fontWeightBold,
    },
    debitAmount: {
      color: '#B95656',
      fontWeight: typography.fontWeightBold,
    },
    runningBalance: {
      fontWeight: typography.fontWeightBold,
    },
    tableWrapper: {
      position: 'relative',
      paddingBottom: '30px',
      minHeight: 'calc(100vh - 420px)',
    },
  }),
  { name: 'StatementsTable' },
);

export default useStyles;
